import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo/Onda_fundo_azul.png'


const _withScopeId = n => (_pushScopeId("data-v-3e150c62"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container p-0",
  style: {"margin":"0 auto"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<nav class=\"navbar\" style=\"position:relative;\" data-v-3e150c62><div class=\"container-fluid\" style=\"text-align:center;\" data-v-3e150c62><div class=\"navbar-brand\" data-v-3e150c62><span style=\"font-size:1.7rem;color:#fff;font-weight:bold;\" data-v-3e150c62>Carteira de Consultores</span></div></div><div style=\"background-color:#0045B5;position:absolute;top:0;bottom:0;right:0;left:0;z-index:-1;overflow:hidden;\" data-v-3e150c62><img src=\"" + _imports_0 + "\" style=\"width:100%;margin-top:25px;\" alt=\"\" data-v-3e150c62></div></nav>", 1)
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "consultor",
  class: "form-label fs-2",
  style: {"font-weight":"600"}
}, "Selecione um Consultor:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { role: "status" }, "Carregando...", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fs-2",
  style: {"font-weight":"600","color":"#3F4254","margin-bottom":"0.5rem"}
}, "Lojas associadas:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "35",
  height: "35",
  viewBox: "0 0 25 25",
  fill: "#dedede",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.6602 21.6162L19.792 16.748C19.5723 16.5283 19.2744 16.4062 18.9619 16.4062H18.166C19.5137 14.6826 20.3145 12.5146 20.3145 10.1562C20.3145 4.5459 15.7686 0 10.1582 0C4.54785 0 0.00195312 4.5459 0.00195312 10.1562C0.00195312 15.7666 4.54785 20.3125 10.1582 20.3125C12.5166 20.3125 14.6846 19.5117 16.4082 18.1641V18.96C16.4082 19.2725 16.5303 19.5703 16.75 19.79L21.6182 24.6582C22.0771 25.1172 22.8193 25.1172 23.2734 24.6582L24.6553 23.2764C25.1143 22.8174 25.1143 22.0752 24.6602 21.6162ZM10.1582 16.4062C6.70605 16.4062 3.9082 13.6133 3.9082 10.1562C3.9082 6.7041 6.70117 3.90625 10.1582 3.90625C13.6104 3.90625 16.4082 6.69922 16.4082 10.1562C16.4082 13.6084 13.6152 16.4062 10.1582 16.4062Z",
    fill: "#dedede"
  })
], -1))
const _hoisted_11 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"200px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  style: {"width":"3rem","height":"3rem"},
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "card mb-3 shadow-sm" }
const _hoisted_17 = { class: "card-header p-3" }
const _hoisted_18 = { class: "card-title" }
const _hoisted_19 = { class: "card-body d-flex justify-content-between gap-3 p-3" }
const _hoisted_20 = { class: "d-flex flex-column gap-2" }
const _hoisted_21 = { class: "card-text cor_texto_1 mb-0" }
const _hoisted_22 = { class: "card-text cor_texto_1 mb-0" }
const _hoisted_23 = { class: "card-text cor_texto_1" }
const _hoisted_24 = { class: "align-self-end" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 3,
  class: "text-center mt-4",
  style: {"color":"#606266"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ModalDadosLoja = _resolveComponent("ModalDadosLoja")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_select, {
            id: "consultor",
            class: "w-100",
            filterable: "",
            "value-key": "id",
            placeholder: "Selecione...",
            modelValue: _ctx.consultorSelected,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.consultorSelected) = $event))
          }, {
            default: _withCtx(() => [
              (_ctx.loadConsultores)
                ? (_openBlock(), _createBlock(_component_el_option, {
                    key: 0,
                    value: "",
                    class: "d-flex align-items-center gap-2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consultores, (consultor) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: consultor.id,
                  value: consultor,
                  label: consultor.nome
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        (_ctx.consultorSelected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              (_ctx.consultorSelected)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    modelValue: _ctx.fastFind,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fastFind) = $event)),
                    placeholder: "Pesquise por Nome, Cnpj ou código Abadi"
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "el-input__icon" }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.loadDados)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                : _createCommentVNode("", true),
              (_ctx.arrayDados.length > 0 && !_ctx.loadDados)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayDados, (loja) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-md-6 col-lg-4",
                          key: loja.id
                        }, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("h5", _hoisted_18, _toDisplayString(loja.nomeFantasia), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("p", _hoisted_21, [
                                  _createTextVNode("OS's dia anterior: "),
                                  _createElementVNode("strong", null, _toDisplayString(loja.qtd_orcamentos), 1)
                                ]),
                                _createElementVNode("p", _hoisted_22, [
                                  _createTextVNode("OS's Pagas dia anterior: "),
                                  _createElementVNode("strong", null, _toDisplayString(loja.qtd_orcamentos_pagos), 1)
                                ]),
                                _createElementVNode("p", _hoisted_23, [
                                  _createTextVNode("Consultas dia anterior: "),
                                  _createElementVNode("strong", null, _toDisplayString(loja.qtd_orcamentos_abertos), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.openModal(loja)),
                                  style: {"min-width":"max-content","background-color":"#FC6507","border":"none","border-radius":"9px","padding":"0.5rem","padding-right":"1rem","padding-left":"1rem","color":"#fff"}
                                }, " + ", 8, _hoisted_25)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.arrayDados.length === 0 && !_ctx.loadDados)
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, "Não foram encontradas lojas para o consultor selecionado."))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalDadosLoja, {
      data: _ctx.loja,
      fechaModal: _ctx.fechaModal
    }, null, 8, ["data", "fechaModal"])
  ], 64))
}